import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider, useAuth } from "@/features/auth/AuthContext";
import { GoogleSignInButton } from "@/features/auth/GoogleSignInButton";
import { Dashboard } from "@/features/dashboard/Dashboard";
import { Discovery } from "@/features/discovery/Discovery";
import { GlassSurface } from "@/ui/GlassSurface";

// The VR bundle (three.js + R3F + xr) is heavy — load it only on /vr.
const VRApp = lazy(() => import("@/vr/VRApp").then((m) => ({ default: m.VRApp })));

function Landing() {
  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <GlassSurface className="max-w-md p-8 text-center">
        <h1 className="text-3xl font-semibold">Your space, your widgets</h1>
        <p className="mt-2 opacity-80">
          Build a personal startpage, fork others, and explore it in VR.
        </p>
        <div className="mt-6 flex justify-center">
          <GoogleSignInButton />
        </div>
      </GlassSurface>
    </div>
  );
}

function Home() {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8 opacity-70">Loading…</div>;
  return user ? <Dashboard /> : <Landing />;
}

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/discover" element={<Discovery />} />
          <Route
            path="/vr"
            element={
              <Suspense fallback={<div className="p-8">Loading VR…</div>}>
                <VRApp />
              </Suspense>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
